module.exports = __webpack_public_path__ + "img/rank_corporal.f934cadc.svg";